import { render, staticRenderFns } from "./applyCard.vue?vue&type=template&id=a1fa06ae&scoped=true&"
import script from "./applyCard.vue?vue&type=script&lang=js&"
export * from "./applyCard.vue?vue&type=script&lang=js&"
import style0 from "./applyCard.vue?vue&type=style&index=0&id=a1fa06ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1fa06ae",
  null
  
)

export default component.exports